import { Box, Button, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { Add, LinkOff } from '@mui/icons-material';

import { BindingsActions } from '../BindingsActions';
import { BindingsTable } from '../BindingsTable';
import { CompetitorBindingTable } from '../CompetitorBindingTable';

import { BindingsPanelProps } from './BindingsPanel.types';

export function BindingsPanel({
  isMobile,
  readOnly = false,
  selectedCompetitorStation,
  selectedOkkoStation,
  okkoBindingDetails,
  okkoBindingsForCompetitor,
  influenceTypes,
  locationTypes,
  addingMode,
  hasChanges,
  resetting,
  onDeleteBinding,
  onDeleteAll,
  onUpdateField,
  onStartAdding,
  onReset,
  onSave
}: BindingsPanelProps) {
  return (
    <Box className={`bindings-container ${isMobile ? 'mobile-layout' : ''}`}>
      <Card className="bindings-card">
        <CardHeader
          title="Існуюча зв'язка останньої вибраної АЗК"
          className="bindings-card-header bindings-card-title"
        />
        <CardContent className="bindings-content">
          {!selectedCompetitorStation && !selectedOkkoStation && okkoBindingDetails.length === 0 && (
            <Box className="no-bindings-container">
              <LinkOff className="no-bindings-icon" />
              <Typography>Оберіть АЗС для перегляду прив'язок</Typography>
            </Box>
          )}

          {!selectedOkkoStation &&
            selectedCompetitorStation &&
            (okkoBindingsForCompetitor.length === 0 ? (
              <Box className="no-bindings-container">
                <LinkOff className="no-bindings-icon" />
                <Typography>Немає прив'язок для обраного конкурента</Typography>
              </Box>
            ) : (
              <CompetitorBindingTable
                bindings={okkoBindingsForCompetitor}
                selectedCompetitorStation={selectedCompetitorStation}
                influenceTypes={influenceTypes}
                locationTypes={locationTypes}
              />
            ))}

          {selectedOkkoStation && okkoBindingDetails.length > 0 && (
            <>
              <BindingsTable
                selectedOkkoStation={selectedOkkoStation}
                bindingDetails={okkoBindingDetails}
                resetting={resetting}
                readOnly={readOnly}
                influenceTypes={influenceTypes}
                locationTypes={locationTypes}
                onDeleteBinding={onDeleteBinding}
                onDeleteAll={onDeleteAll}
                onUpdateField={onUpdateField}
              />

              {!readOnly && (
                <Box className="action-buttons-container">
                  <Button
                    startIcon={<Add className="add-icon" />}
                    disabled={addingMode || !selectedOkkoStation}
                    onClick={onStartAdding}
                    className="add-competitor-button"
                  >
                    Додати АЗК конкурента
                  </Button>
                </Box>
              )}

              {!readOnly && (
                <BindingsActions
                  hasChanges={hasChanges}
                  addingMode={addingMode}
                  resetting={resetting}
                  onReset={onReset}
                  onSave={onSave}
                />
              )}
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
